// constants
import { PanelRateCardActionTypes } from './constants';
import { PanelRateCard as PanelRateCardData } from 'src/types/panelRateCard';

export type PanelRateCardActionType = {
    type:
        | PanelRateCardActionTypes.API_RESPONSE_SUCCESS
        | PanelRateCardActionTypes.API_RESPONSE_ERROR
        | PanelRateCardActionTypes.ADD_PANEL_RATE_CARD
        | PanelRateCardActionTypes.EDIT_PANEL_RATE_CARD
        | PanelRateCardActionTypes.GET_PANEL_RATE_CARD
        | PanelRateCardActionTypes.GET_PANEL_RATE_CARDS
        | PanelRateCardActionTypes.RESET
        | PanelRateCardActionTypes.RESET_SUCCESS
        | PanelRateCardActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const panelRateCardApiResponseSuccess = (
    actionType: string,
    data: PanelRateCardData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): PanelRateCardActionType => ({
    type: PanelRateCardActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const panelRateCardApiResponseError = (
    actionType: string,
    data: PanelRateCardData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): PanelRateCardActionType => ({
    type: PanelRateCardActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addPanelRateCard = (params: any): PanelRateCardActionType => ({
    type: PanelRateCardActionTypes.ADD_PANEL_RATE_CARD,
    payload: params,
});

export const editPanelRateCard = (params: any): PanelRateCardActionType => ({
    type: PanelRateCardActionTypes.EDIT_PANEL_RATE_CARD,
    payload: params,
});

export const GetPanelRateCards = (params: any): PanelRateCardActionType => ({
    type: PanelRateCardActionTypes.GET_PANEL_RATE_CARDS,
    payload: params,
});

export const GetPanelRateCard = (params: any): PanelRateCardActionType => ({
    type: PanelRateCardActionTypes.GET_PANEL_RATE_CARD,
    payload: params,
});

export const resetPanelRateCard = (): PanelRateCardActionType => ({
    type: PanelRateCardActionTypes.RESET,
    payload: {},
});

export const resetPanelRateCardSuccess = (): PanelRateCardActionType => ({
    type: PanelRateCardActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetPanelRateCardError = (): PanelRateCardActionType => ({
    type: PanelRateCardActionTypes.RESET_ERROR,
    payload: {},
});
